import { render, staticRenderFns } from "./statisticsUp.vue?vue&type=template&id=f80498c8&scoped=true"
import script from "./statisticsUp.vue?vue&type=script&lang=js"
export * from "./statisticsUp.vue?vue&type=script&lang=js"
import style0 from "./statisticsUp.vue?vue&type=style&index=0&id=f80498c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80498c8",
  null
  
)

export default component.exports